<template>
  <div class="login" v-if="imgPath">
    <img class="bg" src="../../../assets/img/taiko/login/bg.png" alt="">
    <div class="title">
      <!-- <div class="yellow">将下方二维码对准机台扫描处</div>
      <div class="white">可用机台【TAK】</div> -->
      <img :src="titleImg" alt="" />
    </div>
    <div class="qr_code">
      <img :src="imgPath" alt="" />
      <div class="limited_tip" v-if="expireTime > 0">
        二维码有效期限：
        <span class="red">{{ count }}</span>
      </div>
      <div
        class="limited_tip"
        v-if="expireTime <= 0 && serverState !== 'mainte'"
      >
        已过期
      </div>
      <div class="limited_tip" v-if="serverState === 'mainte'">
        <div class="red">登入二维码系统维护中</div>
        <div>例行维护时间：3:00 ～ 6:00</div>
      </div>
    </div>
    <!-- <div class="logo">
      <img :src="logoImg" alt="">
    </div> -->
  </div>
</template>

<script>
import parseQueryString from "outils/parseQueryString";
import unhappyImg from "assets/img/taiko/login/unhappy.png";
import titleImg from "assets/img/taiko/login/title.png";
import logoImg from "assets/img/taiko/login/wahlap_logo.png";
import { checkImgExists } from "assets/js/tool";
export default {
  name: "login",
  data() {
    return {
      titleImg,
      logoImg,
      imgPath: "",
      expireTime: 0,
      count: "",
      serverState: "", //维护状态mainte
    };
  },
  mounted() {
    const query = parseQueryString(location.search);
    console.log(query);
    if (query.imgPath) {
      checkImgExists(query.imgPath)
        .then(() => {
          this.imgPath = query.imgPath;
        })
        .catch(() => {
          this.imgPath = unhappyImg;
          console.log("无效链接");
        });
    }
    if (query.expireTime && query.startTime) {
      // let timestamp = Date.parse(new Date()) + Number(query.expireTime) * 1000;
      // this.expireTime = timeFormat(timestamp);
      let passTime =
        Date.parse(new Date()) / 1000 - Number(query.startTime);
      if (passTime <= query.expireTime) {
        console.log(passTime)
        this.expireTime = query.expireTime-passTime;
        this.Time();
      }
    }
    //进入维护
    if (query.serverState === "mainte") {
      this.imgPath = unhappyImg;
      this.serverState = query.serverState;
    }
  },
  methods: {
    // 格式化函数——天 时 分 秒
    countDown() {
      // let d = parseInt(this.expireTime / (24 * 60 * 60));
      // d = d < 10 ? "0" + d : d;
      // let h = parseInt((this.expireTime / (60 * 60)) % 24);
      // h = h < 10 ? "0" + h : h;
      let m = parseInt((this.expireTime / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(this.expireTime % 60);
      s = s < 10 ? "0" + s : s;
      this.count = m + "分" + s + "秒";
    },
    //定时器没过1秒参数减1
    Time() {
      let intTime = setInterval(() => {
        if (this.expireTime === 0) {
          clearInterval(intTime);
          return;
        }
        this.expireTime -= 1;
        this.countDown();
      }, 1000);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "assets/scss/index.scss";
@import "./index.scss";
</style>